import {TouchableOpacity} from 'react-native';
import FastImage from 'react-native-fast-image';

import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import styled, {css} from 'styled-components/native';

interface Props {
  between: boolean;
}
interface ButtonProp {
  rightPosition?: boolean;
}

export const Container = styled.View<Props>`
  align-items: center;
  flex-direction: row;
  margin: 0 24px;
  z-index: 303;

  margin-bottom: ${RFValue(16)}px;

  ${({between}) =>
    between &&
    css`
      justify-content: space-between;
    `}
`;

//@ts-ignore
export const ButtonIcon = styled(TouchableOpacity)<ButtonProp>`
  z-index: 301;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  margin-left: -12px;
  margin-top: -12px;

  ${({rightPosition}) =>
    rightPosition &&
    css`
      margin-right: -12px;
      margin-left: 0px;
    `}
`;

export const IconHeader = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(22)}px;
`;

//@ts-ignore
export const NeedSupportButtonImage = styled(FastImage)`
  width: ${RFValue(95)}px;
  height: ${RFValue(50)}px;
`;
export const TitleContainer = styled.View`
  z-index: 1;
  position: absolute;
  width: 100%;
  justify-content: center;
  flex-direction: row;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
`;
